// src/components/TechStackScroller.jsx
import React from "react";
import techStack from "../data/techstack.json";

export default function TechStackScroller() {
  return (
    <section className="w-full px-4 py-12">
      <p className="font-mono text-[12px] uppercase tracking-[0.1em] text-muted dark:text-pale mb-5">
        Tech stack
      </p>
      <div className="flex flex-wrap gap-2.5">
        {techStack.map((tech, i) => (
          <div
            key={i}
            className="flex items-center gap-2 border border-black/10 dark:border-white/10 rounded-md bg-white dark:bg-[#101315] pl-1.5 pr-3 py-1.5"
          >
            {/* light tile keeps every logo legible in both themes */}
            <span className="w-6 h-6 rounded bg-white flex items-center justify-center shrink-0">
              <img
                src={tech.icon}
                alt={`${tech.name} logo`}
                className="w-4 h-4 object-contain"
              />
            </span>
            <span className="font-mono text-[12px] text-muted dark:text-pale">
              {tech.name}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
